/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSubsystemRequestDto } from './CreateSubsystemRequestDto';
import {
    CreateSubsystemRequestDtoFromJSON,
    CreateSubsystemRequestDtoFromJSONTyped,
    CreateSubsystemRequestDtoToJSON,
    CreateSubsystemRequestDtoToJSONTyped,
} from './CreateSubsystemRequestDto';

/**
 * 
 * @export
 * @interface BatchImportSubsystemsRequestDto
 */
export interface BatchImportSubsystemsRequestDto {
    /**
     * Array of subsystems to import
     * @type {Array<CreateSubsystemRequestDto>}
     * @memberof BatchImportSubsystemsRequestDto
     */
    items: Array<CreateSubsystemRequestDto>;
}

/**
 * Check if a given object implements the BatchImportSubsystemsRequestDto interface.
 */
export function instanceOfBatchImportSubsystemsRequestDto(value: object): value is BatchImportSubsystemsRequestDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BatchImportSubsystemsRequestDtoFromJSON(json: any): BatchImportSubsystemsRequestDto {
    return BatchImportSubsystemsRequestDtoFromJSONTyped(json, false);
}

export function BatchImportSubsystemsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchImportSubsystemsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CreateSubsystemRequestDtoFromJSON)),
    };
}

export function BatchImportSubsystemsRequestDtoToJSON(json: any): BatchImportSubsystemsRequestDto {
    return BatchImportSubsystemsRequestDtoToJSONTyped(json, false);
}

export function BatchImportSubsystemsRequestDtoToJSONTyped(value?: BatchImportSubsystemsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CreateSubsystemRequestDtoToJSON)),
    };
}

